export const VIEW_MODE = {
  MAP_BASED_SELECTOR: 'map',
  LIST_BASED_SELECTOR: 'list',
  FREE_CHART_SELECTOR: 'free-list',
  NA_CHART_SELECTOR: 'na-list',
  BUNDLED_CHART_SELECTOR: 'bundled-list'
};

export enum isConfirmValue {
  isTrial = 0,
  isExpireTrialNow = 1,
  isBuyChart = 2,
}
